import React, { useState } from 'react';
import { PulsingIcon } from './components/PulsingIcon';
import { SelectionStep } from './components/SelectionStep';
import { SummaryScreen } from './components/SummaryScreen';
import { BodySelector } from './components/BodySelector';
import { SeveritySlider } from './components/SeveritySlider';
export function App() {
  const [isActive, setIsActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [selections, setSelections] = useState({
    bodyPosition: '',
    severity: '',
    bodyPart: '',
    symptoms: []
  });
  const handleIconClick = () => {
    setIsActive(true);
    setCurrentStep(1);
  };
  const handleSelection = (key, value) => {
    setSelections(prev => ({
      ...prev,
      [key]: value
    }));
    setCurrentStep(currentStep + 1);
  };
  const handleMultiSelection = (key, value) => {
    setSelections(prev => {
      const currentValues = prev[key] || [];
      const newValues = currentValues.includes(value) ? currentValues.filter(item => item !== value) : [...currentValues, value];
      return {
        ...prev,
        [key]: newValues
      };
    });
  };
  const handleSymptomComplete = () => {
    setCurrentStep(currentStep + 1);
  };
  const handleReset = () => {
    setIsActive(false);
    setCurrentStep(0);
    setSelections({
      bodyPosition: '',
      severity: '',
      bodyPart: '',
      symptoms: []
    });
  };
  const bodyPositionOptions = ['Front', 'Back'];
  const severityOptions = ['Mild', 'Moderate', 'Severe'];
  const bodyPartOptions = ['Hand', 'Arm', 'Leg', 'Face', 'Neck', 'Chest', 'Back', 'Stomach', 'Foot'];
  const symptomOptions = ['Red', 'Sore', 'Itchy', 'Inflamed', 'Flakey', 'Burning', 'Swollen'];
  return <div className="bg-gray-100 min-h-screen w-full flex flex-col items-center justify-center p-4" data-id="element-0">
      <div className="w-full max-w-md mx-auto relative" data-id="element-1">
        {!isActive && <div className="flex flex-col items-center justify-center" data-id="element-2">
            <h1 className="text-2xl font-bold mb-8 text-center" data-id="element-3">
              Skin Tracker
            </h1>
            <PulsingIcon onClick={handleIconClick} data-id="element-4" />
            <p className="mt-8 text-center text-gray-600" data-id="element-5">
              Tap the icon to track a skin condition
            </p>
          </div>}
        {isActive && currentStep === 1 && <div className="bg-white rounded-lg shadow-lg p-6 animate-fade-in" data-id="element-6">
            <h2 className="text-xl font-bold mb-6 text-center" data-id="element-7">
              Select Body Position
            </h2>
            <BodySelector onSelect={value => handleSelection('bodyPosition', value)} data-id="element-8" />
          </div>}
        {isActive && currentStep === 2 && <div className="bg-white rounded-lg shadow-lg p-6 animate-fade-in" data-id="element-9">
            <h2 className="text-xl font-bold mb-6 text-center" data-id="element-10">
              Select Severity
            </h2>
            <SeveritySlider onSelect={value => handleSelection('severity', value)} data-id="element-11" />
          </div>}
        {isActive && currentStep === 3 && <SelectionStep title="Select Body Part" options={bodyPartOptions} onSelect={value => handleSelection('bodyPart', value)} data-id="element-12" />}
        {isActive && currentStep === 4 && <SelectionStep title="Select Symptoms" options={symptomOptions} multiSelect={true} selectedValues={selections.symptoms} onSelect={value => handleMultiSelection('symptoms', value)} onComplete={handleSymptomComplete} data-id="element-13" />}
        {isActive && currentStep === 5 && <SummaryScreen selections={selections} onReset={handleReset} data-id="element-14" />}
      </div>
    </div>;
}